import React from 'react';
import { HouseTemperatureIcon } from 'assets/icons/brikks/HouseTemperatureIcon';
import { Draggable } from 'components/drag-and-drop';
import { Brikk } from 'components/Brikk';
import { BrikkModal } from 'components/modals/BrikkModal';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';
import { ClimatePreview } from 'components/brikks/smartness/Climate/components/ClimatePreview';
import { ClimateModal } from 'components/brikks/smartness/Climate/components/ClimateModal';

export const Climate = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = React.useState(false);

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };
 
  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<HouseTemperatureIcon />}
            heading="climateBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content center>
            <ClimatePreview />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={handleOpenModal}
              brikkNameIntl="climate"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Climate info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />

      <BrikkModal
        isOpen={isModalOpen}
        heading="climate"
        onClose={() => setIsModalOpen(false)}
      >
        <ClimateModal />
      </BrikkModal>
    </>
  );
};
